import { LocalStorage } from '../../../common/helpers/local-storage';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const touchpointStartup = async (): Promise<void> => {
  const computerName = LocalStorage.computerName() ? LocalStorage.computerName() : '1';
  const axiosConfig: AxiosRequestConfig = {
    url: '/touchPoint/startup',
    method: 'POST',
    data: { computerName, domainName: 'corp.ncr.com' },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: false,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'touchpoint-startup' },
  };

  return emeraldRequest(emeraldRequestParams);
};
